import qs from 'qs'

export const trackSplunk = (entries, customSplunkUrl = null) => {
  const { REACT_APP_SPLUNK_URL } = process.env
  return fetch(`${customSplunkUrl || REACT_APP_SPLUNK_URL}/?${qs.stringify(entries)}`)
}

export const trackStreamfully = (entries, customStreamfullyUrl = null) => {
  const { REACT_APP_STREAMFULLY_URL } = process.env
  const { et, st, ...entriesRest } = entries
  return fetch(`${customStreamfullyUrl || REACT_APP_STREAMFULLY_URL}/?${qs.stringify({ st, et })}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: JSON.stringify(entriesRest),
  })
}
